// Login-as ("impersonation") state — ticket 73.
//
// SuperAdminPage swaps the owner's JWT for a tenant/borrower token and keeps the
// owner's token aside so the banner's EXIT button can restore it. All reads and
// writes of that state go through here so logout, the login page, and every
// fresh-token path clear it the same way, and the banner can't outlive the
// session that created it.
import { setToken, getToken, clearImpersonation, IMPERSONATION_KEY } from './api';

export { clearImpersonation };

export function getImpersonation() {
  try { return JSON.parse(localStorage.getItem(IMPERSONATION_KEY) || 'null'); }
  catch { return null; }
}

// True when the stored flag was written for the user who is signed in now.
// A flag left behind by an earlier session (expired token, signed in as someone
// else) has a different as_email and must not show a banner.
export function impersonationMatches(imp, user) {
  if (!imp || !user) return false;
  if (!imp.as_email || !user.email) return true; // legacy flag without email: trust it
  return imp.as_email.toLowerCase() === user.email.toLowerCase();
}

export function beginImpersonation({ accessToken, originalEmail, tenant_name, as_email, as_role }) {
  const current = getToken();
  if (current && !localStorage.getItem('loa_original_token')) {
    localStorage.setItem('loa_original_token', current);
    if (originalEmail) localStorage.setItem('loa_original_email', originalEmail);
  }
  setToken(accessToken);
  localStorage.setItem(IMPERSONATION_KEY, JSON.stringify({
    tenant_name, as_email, as_role, started_at: new Date().toISOString(),
  }));
}

// Restore the owner's token (when we still have it) and drop the flag.
// Returns true when a token was restored, false when the caller should treat
// the user as signed out.
export function exitImpersonation() {
  const orig = localStorage.getItem('loa_original_token');
  clearImpersonation();
  if (orig) { setToken(orig); return true; }
  return false;
}
